import { getBackendUrl } from "@Utils";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { setShowNotification } from "../../actions/notification";
import ToolTipComponent from "@CubeComponents/html/tooltip";
import IconComponent from "@CubeComponents/icons";
import axiosWrapper from "../../services/axiosWrapper";
import { formCategories } from "@Helpers";

function ActionCards() {
  const { t } = useTranslation();
  const [moduleCount, setModuleCount] = useState({});
  const [actions, setActions] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const { customModules, layout } = useSelector((state) => state);

  const getModulesCount = async () => {
    const res = await axiosWrapper.post(`${getBackendUrl()}/projects/getActionableCount`);
    if (res.data.status) {
      setModuleCount(res.data.data);
    }
  };

  useEffect(() => {
    getModulesCount();
  }, []);

  useEffect(() => {
    const modules = [
      {
        id: 1,
        count: moduleCount.reviews?.count || 0,
        label: "Reviews",
        icon: "Review",
        module: "reviews",
        allow: layout.WORKFLOW?.ENABLE,
        overDueCount: moduleCount.reviews?.overdueCount,
        next3DaysCount: moduleCount.reviews?.next3DaysCount,
        toolContent: `${moduleCount.reviews?.overdueCount || moduleCount.reviews?.next3DaysCount} Review(s) ${
          moduleCount.reviews?.overdueCount ? "exceeded due date" : "approaching due date in 3 day(s)"
        }`,
      },
      {
        id: 2,
        count: moduleCount[formCategories.inspection]?.count || 0,
        label: "Inspections",
        icon: "inspectionForm",
        module: formCategories.inspection,
        allow: layout.INSPECTION?.ENABLE,
        overDueCount: moduleCount[formCategories.inspection]?.overdueCount,
        next3DaysCount: moduleCount[formCategories.inspection]?.next3DaysCount,
        toolContent: `${
          moduleCount[formCategories.inspection]?.overdueCount || moduleCount[formCategories.inspection]?.next3DaysCount
        } Inspections ${
          moduleCount[formCategories.inspection]?.overdueCount
            ? "exceeded due date"
            : "approaching due date in 3 day(s)"
        }`,
      },
      {
        id: 3,
        count: moduleCount[formCategories.progressUpdates]?.count || 0,
        label: "Progress updates",
        icon: "ProgressUpdates",
        module: formCategories.progressUpdates,
        allow: layout.PROGRESS_UPDATES?.ENABLE,
        overDueCount: moduleCount[formCategories.progressUpdates]?.overdueCount,
        next3DaysCount: moduleCount[formCategories.progressUpdates]?.next3DaysCount,
        toolContent: `${
          moduleCount[formCategories.progressUpdates]?.overdueCount ||
          moduleCount[formCategories.progressUpdates]?.next3DaysCount
        } Progress updates ${
          moduleCount[formCategories.progressUpdates]?.overdueCount
            ? "exceeded due date"
            : "approaching due date in 3 day(s)"
        }`,
      },
      {
        id: 4,
        count: moduleCount[formCategories.generalForms]?.count || 0,
        label: "General Forms",
        icon: "generalForms",
        module: formCategories.generalForms,
        allow: layout.GENERAL_FORMS?.ENABLE,
        overDueCount: moduleCount[formCategories.generalForms]?.overdueCount,
        next3DaysCount: moduleCount[formCategories.generalForms]?.next3DaysCount,
        toolContent: `${
          moduleCount[formCategories.generalForms]?.overdueCount ||
          moduleCount[formCategories.generalForms]?.next3DaysCount
        } General Forms ${
          moduleCount[formCategories.generalForms]?.overdueCount
            ? "exceeded due date"
            : "approaching due date in 3 day(s)"
        }`,
      },
      {
        id: 5,
        count: moduleCount[formCategories.permitToWork]?.count || 0,
        label: "Permit To Work",
        icon: "PermitToWork",
        module: formCategories.permitToWork,
        allow: layout.PERMIT_TO_WORK?.ENABLE,
        overDueCount: moduleCount[formCategories.permitToWork]?.overdueCount,
        next3DaysCount: moduleCount[formCategories.permitToWork]?.next3DaysCount,
        toolContent: `${
          moduleCount[formCategories.permitToWork]?.overdueCount ||
          moduleCount[formCategories.permitToWork]?.next3DaysCount
        } Permit To Work ${
          moduleCount[formCategories.permitToWork]?.overdueCount
            ? "exceeded due date"
            : "approaching due date in 3 day(s)"
        }`,
      },
    ];
    customModules?.map((module, index) => {
      modules.push({
        id: index + 6,
        count: moduleCount[module.resourceType]?.count || 0,
        label: module.name,
        icon: module.icon,
        module: module.resourceType,
        allow: true,
        overDueCount: moduleCount[module.resourceType]?.overdueCount,
        next3DaysCount: moduleCount[module.resourceType]?.next3DaysCount,
        toolContent: `${
          moduleCount[module.resourceType]?.overdueCount || moduleCount[module.resourceType]?.next3DaysCount
        } ${module.name} ${
          moduleCount[module.resourceType]?.overdueCount ? "exceeded due date" : "approaching due date in 3 day(s)"
        }`,
      });
    });
    setActions(modules);
  }, [customModules, moduleCount]);

  useEffect(() => {
    let total = 0;
    actions.map((module) => {
      if (module.allow) {
        total += module.count;
      }
    });
    setTotalCount(total);
  }, [actions]);

  const dispatch = useDispatch();
  const closeNotificationModal = () => {
    dispatch(setShowNotification(false));
  };

  return (
    <div className="w-full flex flex-col items-center">
      <div className="w-full max-w-3xl p-3">
        <div className="ps-8 py-4 font-semibold">
          Take Action{" "}
          <span className="inline-flex items-center p-1 ms-2 text-sm font-bold bg-[#ECF3FE] rounded">{totalCount}</span>
        </div>
        <hr className="my-2 border-blue-50" />
      </div>
      <div className="flex flex-wrap gap-3 pe-6 ps-8 w-full">
        {actions.map(
          (action) =>
            action.allow &&
            action.count > 0 && (
              <Link
                to={`/notifications?section=takeAction&module=${action.module}`}
                onClick={closeNotificationModal}
                className="no-underline text-inherit"
                key={action.id}
              >
                <div className="flex items-center justify-between rounded-sg p-4 w-full border cursor-pointer">
                  <div className="flex flex-wrap gap-3 items-center min-w-0">
                    <span>
                      <IconComponent name={action.icon} />
                    </span>
                    <span className="text-xl font-bold">{action.count}</span>
                    <span className="text-base sm:text-lg font-semibold whitespace-nowrap">{action.label}</span>
                    {(action.overDueCount > 0 || action.next3DaysCount > 0) && (
                      <ToolTipComponent
                        position="bottom"
                        content={action.toolContent}
                        className="max-w-[200px] break-words"
                      >
                        <span
                          className={`w-5 h-5 flex items-center justify-center rounded-full text-white text-xs cursor-default ${
                            action.overDueCount ? "bg-red-500" : "bg-yellow-400"
                          }`}
                        >
                          !
                        </span>
                      </ToolTipComponent>
                    )}
                  </div>
                </div>
              </Link>
            ),
        )}
      </div>
      <div className="mt-3 font-semibold flex items-center self-start px-12 py-3">
        <Link to="/notifications?section=takeAction&module=reviews">
          <span onClick={closeNotificationModal}>
            {t("View All Actions")} <span className="ms-2">↗</span>
          </span>
        </Link>
      </div>
    </div>
  );
}

export default ActionCards;
